export default {"src":"/_next/static/media/logo-white.14ff275e.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};